import React from 'react';
import { Modal } from 'components/molecules';
import { GoogleMap, MapPin } from 'components/core/GoogleMap';
import PropTypes from 'prop-types';
import './MapView.scss';

export function MapView({ isOpen, onClose, facility }) {
	if (!facility?.location) return null;
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Map View"
			bodyClassName="map-view-modal-body"
		>
			{isOpen && (
				<div className="map-view-two">
					<GoogleMap center={facility.location}>
						<MapPin location={facility.location} />
					</GoogleMap>
				</div>
			)}
		</Modal>
	);
}

MapView.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	facility: PropTypes.object,
	bodyClassName: PropTypes.string,
};
export default MapView;
